import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { FormControl, FormGroup } from '@angular/forms';
import { GalleriaSpettacolo, Spettacolo } from '../../../../shared/interface';
import { Table } from 'primeng/table';
import { ImagePipe } from '../../../../shared/image.pipe';

@Component({
  selector: 'app-galleria-spettacolo-backoffice',
  templateUrl: './galleria-spettacolo-backoffice.component.html',
  styleUrl: './galleria-spettacolo-backoffice.component.css'
})
export class GalleriaSpettacoloBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private imagePipe: ImagePipe,
  ) {}

  @ViewChild(ConfirmPopup) delete!: ConfirmPopup;

  @Input() spettacolo?: Spettacolo;
  @Input() galleria: GalleriaSpettacolo[] = [];
  @Output() data = new EventEmitter<{galleria: GalleriaSpettacolo[], files: File[]}>();

  files: File[] = [];
  file?: GalleriaSpettacolo;

  add: boolean = false;
  add_image: boolean = false;
  add_files: boolean = false;
  edit: boolean = false;

  immagine: string = '';

  formGalleria!: FormGroup;
  formUpload!: FormGroup;

  /** Cache URL anteprima (evita ricalcoli pipe a ogni CD) */
  private thumbCache = new WeakMap<object, string>();

  ngOnInit(): void {
    this.formGalleria = new FormGroup({
      evidenza: new FormControl(null),
    });

    this.formUpload = new FormGroup({
      files: new FormControl(null),
    });
  }

  thumbSrc(file: GalleriaSpettacolo): string {
    if (file.file_base64) return file.file_base64;
    if (file.file_upload && file.type === 'image') {
      const cached = this.thumbCache.get(file);
      if (cached) return cached;
      const url = URL.createObjectURL(file.file_upload);
      this.thumbCache.set(file, url);
      return url;
    }
    const cached = this.thumbCache.get(file);
    if (cached) return cached;
    const url = this.imagePipe.transform(file.file + '?type=spettacolo') || '';
    this.thumbCache.set(file, url);
    return url;
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onFilesLoad(file: File | File[] | null) {
    this.files = Array.isArray(file) ? file : (file ? [file] : []);
  }

  onAddFilesGalleria(files: File[]) {
    files.map(file => {
      this.galleria.push({
        id: 0,
        file: file.name,
        type: file.type == 'image/png' || file.type?.startsWith('image/') ? 'image' : 'video',
        posizione: 999,
        evidenza: false,
        id_spettacolo: +this.spettacolo!.id,
        data_creazione: new Date(),
        data_aggiornamento: new Date(),
        file_upload: file
      });
    });

    this.data.emit({galleria: this.galleria, files: files});

    this.add = false;
    this.add_files = false;
  }

  onAddFileGalleria(file: string) {
    this.galleria.push({
      id: 0,
      file: 'ImgGalleriaRitagliata_' + this.galleria.filter(f => f.file_base64).length + '.jpg',
      type: 'image',
      posizione: 999,
      evidenza: false,
      id_spettacolo: +this.spettacolo!.id,
      data_creazione: new Date(),
      data_aggiornamento: new Date(),
      file_base64: file
    });

    this.data.emit({galleria: this.galleria, files: this.files});

    this.immagine = '';
    this.add = false;
    this.add_image = false;
  }

  onRemoveFileGalleria(file: GalleriaSpettacolo) {
    this.files = this.files.filter(file_upload => file_upload != file.file_upload);
    this.galleria = this.galleria.filter(file_galleria => file_galleria.file != file.file);
  }

  onOpenEdit(file: GalleriaSpettacolo) {
    this.file = file;
    this.formGalleria.setValue({ evidenza: file.evidenza ? ['evidenza'] : [] });
    this.edit = true;
  }

  onEdit() {
    this.galleria.filter(file => file == this.file).map(file => {
      file.evidenza = this.formGalleria.get('evidenza')?.value ? (this.formGalleria.get('evidenza')?.value.length > 0 ? true : false) : false;
      return file;
    });
    this.onCloseModal();
  }

  onOpenDelete(event: Event, file: GalleriaSpettacolo, index: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il file della galleria?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteGalleriaSpettacolo(file.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close();
            this.galleria.splice(index, 1);
            this.apiService.message("success", "Eliminazione", "Il file della galleria è stato eliminato con successo");
            this.cdr.detectChanges();
          }
        });
      }
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onAnnullaDelete() {
    this.delete.reject();
  }

  onCloseModal() {
    this.add = false;
    this.add_files = false;
    this.add_image = false;
    this.edit = false;
    this.files = [];
  }

}
